import { render, staticRenderFns } from "./AssetType.vue?vue&type=template&id=0871e26e&scoped=true"
import script from "./AssetType.vue?vue&type=script&lang=js"
export * from "./AssetType.vue?vue&type=script&lang=js"
import style0 from "./AssetType.vue?vue&type=style&index=0&id=0871e26e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871e26e",
  null
  
)

export default component.exports